const steps = [
  {
    number: 1,
    title: 'Elige tu giftcard',
    description: 'Selecciona el monto que mejor se adapte a la persona que quieres sorprender.',
  },
  {
    number: 2,
    title: 'Personaliza tu mensaje',
    description:
      'Agrega los datos del destinatario y un mensaje personal para hacer un regalo inigualable.',
  },
  {
    number: 3,
    title: 'Envio inmediato',
    description:
      'La tarjeta regalo se envía al correo del destinatario inmediatamente después de la compra.',
  },
];

export default function HowItWorks() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p
            className="text-sm font-bold uppercase tracking-widest mb-3"
            style={{ color: '#00A19B' }}
          >
            Tres simples pasos
          </p>
          <h2 className="text-3xl lg:text-4xl font-extrabold text-[#373A36]">Como funciona?</h2>
        </div>

        <div className="space-y-10">
          {steps.map((step) => (
            <div key={step.number} className="flex items-start gap-6">
              <div
                className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-lg font-extrabold text-[#373A36]"
                style={{ background: '#E0DF00' }}
              >
                {step.number}
              </div>
              <div>
                <h3 className="text-lg font-bold text-[#373A36] mb-1">{step.title}</h3>
                <p className="text-[#6b6e68] text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
